import React, { useState, useContext, useEffect } from 'react';
import { ProductContext } from '@components/Context';
import { getProductComment } from '@service/api';
import CommentItem from '@modules/Comment/CommentItem';
import Toast from '@components/Toast';
import './product-comment.scss';

function ProductComment() {
    const productContext: any = useContext(ProductContext);
    const [comment, setComment]: any = useState();
    const { id } = productContext?.product || {};
    useEffect(() => {
        if(id) {
            getProductComment(id, 2, 0, 'likes')
                .then((res: any) => {
                    setComment(res);
                })
        }
    }, [id]);

    function goToCommentList() {
        Toast('请前往APP内查看更多精彩内容');
    }

    if(!comment?.comments?.length) {
        return null;
    }

    return (
        <div className="m-comment">
            <div className="title" onClick={goToCommentList}>
                商品评价({comment?.total})
            </div>
            <div className="comment-container">
                {comment?.tagInfos && comment.tagInfos.length &&
                    <div className="tag-wrap">
                        {comment.tagInfos.map((item: any) => {
                            return (
                                <div className="comment-tag" key={item?.tagName} >
                                    { item?.tagName}({ item?.num})
                                </div>
                            )
                        })}
                    </div >}
                <div className="comment-wrap">
                    {comment.comments.map((item: any, index: number) => {
                        return (
                            <CommentItem key={`comment_${index}`} comment={item} />
                        )
                    })}
                </div>
                <div className="comment-more" onClick={goToCommentList}>
                    查看更多
                    <img className="comment-more-icon" src={require('@images/arrow-right.png').default} />
                </div>
            </div >
        </div >
    )
}

export default ProductComment;